import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import courseIcon from "assets/icons/icon-course.svg";
import userIcon from "assets/icons/icon-user.svg";
import PathwayIcon from "assets/icons/icon-pathway.svg";
import ParentPathwayIcon from "assets/icons/icon-parentpathway.svg";
import ChannelIcon from "assets/icons/icon-channel.svg";
import PlaylistIcon from "assets/icons/icon-playlist-sml.svg";
import { BreadCrumb } from "components/breadcrumb/breadcrumb";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { usePageTitle } from "hooks";
import { useTranslation } from "react-i18next";
import { SUB_HEADER_CONTENT_TYPE } from "utils/constants";

export const SubHeader = ({
  contentType,
  studyModes,
  breadCrumbData,
  handleBreadCrumbClick,
  noDefaultTitle,
}: any): React.ReactElement => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const subHeaderTitle = useSelector((state: RootState) => state.core.subHeaderTitle);
  const { t } = useTranslation();

  const [title, setTitle] = useState<string | null>(subHeaderTitle);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [browserTitle, setBrowserTitle] = useState<string | null>(null);
  const [titleIcon, setTitleIcon] = useState<string | null>(null);
  useEffect(() => {
    if (contentType == "Course") {
      setTitle(t("course").toUpperCase());
      if (studyModes) {
        if (studyModes.length > 1) {
          setTitle(t("hybrid_course"));
        } else {
          if (studyModes.length == 1) {
            setTitle(
              t(studyModes[0].toLowerCase()).toUpperCase() + " " + t("course").toUpperCase(),
            );
          }
        }
      }
    }
  }, [studyModes]);
  useEffect(() => {
    switch (contentType) {
      case "Course":
        // setTitle("COURSE");
        setTitleIcon(courseIcon);
        break;
      case "Search":
        setTitle(t("search_results_title"));
        break;
      case "Profile":
        setTitle(t("profile").toUpperCase());
        setBrowserTitle(t("profile"));
        setTitleIcon(userIcon);
        break;
      case "Pathway":
        setTitle(t("pathway").toUpperCase());
        setTitleIcon(PathwayIcon);
        break;
      case "parentpathway":
        setTitle(t("parent_pathway").toUpperCase());
        setTitleIcon(ParentPathwayIcon);
        break;
      case "Channel":
        setTitle(t("channel").toUpperCase());
        setTitleIcon(ChannelIcon);
        break;
      case "MyLearning":
        setTitle(t("my_learning").toUpperCase());
        setBrowserTitle(t("my_learning"));
        break;
      case "Popular":
        setTitle(t("popular_items"));
        setBrowserTitle(t("popular_items"));
        break;
      case "Recommendations":
        setTitle(t("learningsection_recommendations_title"));
        setBrowserTitle(t("learningsection_recommendations_title"));
        break;
      case "Playlist":
        setTitle(t("playlist").toUpperCase());
        setTitleIcon(PlaylistIcon);
        break;
      case "All":
        if (subHeaderTitle) {
          setTitle(t("my_learning").toUpperCase());
          setBrowserTitle(t("my_learning"));
          setTitleIcon("");
        } else {
          setTitle(t("search_results_title"));
          setBrowserTitle(t("search_results_title"));
          setTitleIcon("");
        }
        break;
      case "Attendance":
        setTitle(t("SESSION ATTENDANCE CONFIRMATION"));
        break;
      case SUB_HEADER_CONTENT_TYPE.ATTENDANCE_CONFIRMATION:
        setTitle(t("subheader_attendace_activity_confirmation"));
        setBrowserTitle(t("subheader_attendace_activity_confirmation"));
        break;
      case SUB_HEADER_CONTENT_TYPE.ACTIVITY_COMPLETION:
        setTitle(t("subheader_activity_completion"));
        break;
      default:
        setTitle(contentType);
        setBrowserTitle(contentType);
        break;
    }
  }, [contentType, subHeaderTitle, t]);
  usePageTitle(browserTitle, noDefaultTitle);
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        height={isMobile ? "0%" : "60px"}
        borderBottom="1px solid #c9c9c9"
        marginBottom={isMobile ? "10px" : "60px"}
        aria-label={`${title}`}
        flexDirection={isMobile ? "column" : "initial"}
      >
        <Box>
          <BreadCrumb
            breadCrumbData={breadCrumbData}
            handleBreadCrumbClick={handleBreadCrumbClick}
          />
        </Box>
        <Box
          height="30px"
          position={isMobile ? "inherit" : "absolute"}
          style={{
            textAlign: "center",
            width: `${isMobile ? "100%" : "50%"}`,
            left: `${isMobile ? "0px" : "50%"}`,
            transform: `${isMobile ? "translate(0px, 0px)" : "translate(-50%, 0px)"}`,
          }}
        >
          <Typography
            style={{
              fontSize: isMobile ? "8px" : "16px",
              color: theme.palette.grey["800"],
              lineHeight: "30px",
              letterSpacing: "2.4px",
              fontFamily: "Arial",
              right: "150px",
              fontWeight: "bold",
            }}
            component="h1"
            aria-label={`${title}`}
          >
            {title}
          </Typography>
          <div
            style={{
              backgroundImage: `url(${titleIcon})`,
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              opacity: title === "Playlist" ? 0.1 : 0.2,
              position: "relative",
              bottom: "30px",
              height: "inherit",
              // right: "150px"
            }}
          ></div>
        </Box>
      </Box>
    </>
  );
};
